export const SET_SELECTED_ORIGIN = 'templates/hotel/searchParameters/selectOrigin/SET_SELECTED_ORIGIN';
